import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// BrowserRouter keeps the previous scroll position across navigations, so a
// footer link swaps the page while leaving the reader at the bottom of it.
// Keyed on location.key rather than pathname so clicking the link for the
// page you're already on scrolls up too.
const ScrollToTop = () => {
  const { key } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [key]);

  return null;
};

export default ScrollToTop;
